export const API_URL = "/museocieloterra-web-api"

export const STATUS_CODE_OK = 200
